(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  const cache = new Map();
  const prefetched = new Set();

  function fetchPage(url) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return fetch(url, { credentials: 'same-origin' })
      .then(res => res.text())
      .then(html => { cache.set(url, html); return html; });
  }

  function swapContent(newDoc) {
    const oldGrid = document.querySelector('[data-product-grid-content]');
    const newGrid = newDoc.querySelector('[data-product-grid-content]');
    if (!oldGrid || !newGrid) return;
    oldGrid.innerHTML = newGrid.innerHTML;
    document.title = newDoc.title;
    document.dispatchEvent(new CustomEvent('ay:content-swapped'));
  }

  function navigateTo(href) {
    fetchPage(href)
      .then(html => {
        const newDoc = new DOMParser().parseFromString(html, 'text/html');
        if (document.startViewTransition) {
          document.startViewTransition(() => swapContent(newDoc));
        } else {
          swapContent(newDoc);
        }
        history.pushState({}, '', href);
      })
      .catch(() => { window.location.href = href; });
  }

  // Resolve the target link for both tabs and PDP color swatches.
  // Swatches are scoped to [data-product-grid-content] so collection-card
  // swatches (which live outside that container) are left alone.
  function resolveTransitionLink(e) {
    const tab = e.target.closest('.ay-tab');
    if (tab && !tab.classList.contains('ay-tab--active')) return tab;

    const swatch = e.target.closest('[data-product-grid-content] a.product-color');
    if (swatch && !swatch.classList.contains('active')) return swatch;

    return null;
  }

  // Prefetch on hover so the swap feels instant
  document.addEventListener('mouseover', e => {
    const link = resolveTransitionLink(e);
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href || prefetched.has(href)) return;
    prefetched.add(href);
    fetchPage(href).catch(() => {});
  });

  // Intercept navigation — event delegation works after DOM swaps too
  document.addEventListener('click', e => {
    const link = resolveTransitionLink(e);
    if (!link) return;
    e.preventDefault();
    navigateTo(link.getAttribute('href'));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
